<template>
  <div>
    <div class="row">
      <div class="col-6 mt-4">
        <idx-card
          :title="`${this.$t('menu.masterSettings.titleNewCompany')}`"
          icon="building"
        >
          <div class="body">
            <div class="row">
              <div class="col-xl-6">
                <div class="form-group">
                  <label for="corporate-name"
                    >{{
                      this.$t('menu.masterSettings.labels.companyName')
                    }}:</label
                  >
                  <input
                    type="text"
                    v-model="corporateName"
                    id="corporate-name"
                    class="form-control"
                    :placeholder="`${this.$t(
                      'menu.masterSettings.placeholderCorporationName',
                    )}`"
                    @keyup="removeInvalidClass('corporate-name')"
                  />
                  <div class="invalid-feedback">
                    {{
                      this.$t(
                        'menu.masterSettings.feedbackInformCorporationName',
                      )
                    }}
                  </div>
                </div>
              </div>
              <div class="col-xl-6">
                <div class="form-group">
                  <label for="company-name"
                    >{{
                      this.$t('menu.masterSettings.labels.fantasyName')
                    }}:</label
                  >
                  <input
                    type="text"
                    v-model="name"
                    id="company-name"
                    class="form-control"
                    :placeholder="`${this.$t(
                      'menu.masterSettings.placeholderCompanyName',
                    )}`"
                    @keyup="removeInvalidClass('company-name')"
                  />
                  <div class="invalid-feedback">
                    {{
                      this.$t('menu.masterSettings.feedbackInformCompanyName')
                    }}
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-6">
                <div class="form-group">
                  <label for="company-cnpj"
                    >{{ this.$t('menu.masterSettings.labels.cnpj') }}:</label
                  >
                  <input
                    type="text"
                    v-model="cnpj"
                    id="company-cnpj"
                    class="form-control"
                    :placeholder="`${this.$t(
                      'menu.masterSettings.placeholderCnpj',
                    )}`"
                    @keyup="removeInvalidClass('company-cnpj')"
                    v-mask="'##.###.###/####-##'"
                  />
                  <div class="invalid-feedback">
                    {{ this.$t('menu.masterSettings.feedbackInformCnpj') }}
                  </div>
                </div>
              </div>
              <div class="col-xl-6">
                <div class="form-group">
                  <label for="company-segment"
                    >{{
                      this.$t('menu.masterSettings.labels.sequence')
                    }}:</label
                  >
                  <input
                    type="text"
                    v-model="mySegment"
                    id="company-segment"
                    class="form-control"
                    :placeholder="`${this.$t(
                      'menu.masterSettings.placeholderSequence',
                    )}`"
                    @keyup="searchSegment"
                  />
                  <div
                    id="options-segment"
                    class="options-segment"
                    style="display: none;"
                  >
                    <ul v-for="(segment, i) in filterSegment" :key="i">
                      <li @click="chooseSegment(segment)">{{ segment }}</li>
                    </ul>
                  </div>
                  <div class="invalid-feedback">
                    {{ this.$t('menu.masterSettings.feedbackInformSequence') }}
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-6">
                <div class="form-group">
                  <label for="company-country"
                    >{{ this.$t('menu.masterSettings.labels.country') }}:</label
                  >
                  <input
                    type="text"
                    v-model="country"
                    id="company-country"
                    class="form-control"
                    :placeholder="`${this.$t(
                      'menu.masterSettings.placeholdercountry',
                    )}`"
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-6">
                <div class="form-group">
                  <label for="user-profile"
                    >{{ this.$t('menu.masterSettings.labels.plan') }}:</label
                  >
                  <b-form-select
                    id="select-plan"
                    v-model="plan.myPlan"
                    :options="plan.options"
                  >
                  </b-form-select>
                  <div class="invalid-feedback">
                    {{ this.$t('menu.masterSettings.feedbackInformBalance') }}
                  </div>
                </div>
              </div>
              <div class="col-xl-6 button-area">
                <div class="form-group">
                  <label for="company-name"
                    >{{
                      this.$t('menu.masterSettings.labels.companyLogo')
                    }}:</label
                  >
                  <b-form-file
                    browse-text="Logo"
                    :placeholder="`${this.$t(
                      'menu.masterSettings.placeholderLogo',
                    )}`"
                    :drop-placeholder="`${this.$t(
                      'menu.masterSettings.placeholderDropFile',
                    )}`"
                    name="image"
                    v-model="file"
                  ></b-form-file>
                  <div class="invalid-feedback">
                    {{
                      this.$t('menu.masterSettings.feedbackInformCompanyName')
                    }}
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-6 custom-area">
                <div v-if="plan.myPlan === 'personalizado'" class="form-group">
                  <label for="sms-balance"
                    >{{
                      this.$t('menu.masterSettings.labels.smsMonth')
                    }}:</label
                  >
                  <input
                    type="number"
                    v-model="qtySms"
                    id="sms-balance"
                    class="form-control"
                  />
                </div>
                <div
                  v-if="plan.myPlan === 'personalizado'"
                  class="form-group ml-3"
                >
                  <label for="email-balance"
                    >{{
                      this.$t('menu.masterSettings.labels.emailMonth')
                    }}:</label
                  >
                  <input
                    type="number"
                    v-model="qtyEmail"
                    id="email-balance"
                    class="form-control"
                  />
                </div>
              </div>
              <div class="col-xl-6 button-area">
                <button @click="addCompany" class="btn btn-primary ml-auto">
                  {{ this.$t('menu.masterSettings.buttonRegister') }}
                </button>
              </div>
            </div>
          </div>
        </idx-card>
      </div>
      <div class="col-6 mt-4">
        <div class="row">
          <div class="col-7">
            <div class="search-companies">
              <input
                type="text"
                class="form-control"
                id="input-company"
                :placeholder="`${this.$t(
                  'menu.masterSettings.placeholderSearch',
                )}`"
                v-model="filter"
                @keyup="filterCompanies"
              />

              <button
                class="btn btn-outline-primary"
                :title="`${this.$t('menu.masterSettings.clear')}`"
                @click="cleanFilter"
              >
                {{ this.$t('menu.masterSettings.clear') }}
              </button>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 mt-4">
            <b-table
              striped
              :items="systemCompanies.companies"
              :fields="fields"
              :busy="loading"
              responsive
            >
              <template v-slot:table-busy>
                <div class="text-center text-primary my-2">
                  <b-spinner type="grow" class="align-middle"></b-spinner>
                </div>
              </template>
              <template v-slot:cell(plan)="row">
                {{ row.item.plan.type }}
              </template>
              <template v-slot:cell(options)="row">
                <div class="buttons-area" style="min-width: 90px;">
                  <button
                    v-b-modal="`edit-company-${row.item._id}`"
                    class="btn btn-outline-primary"
                  >
                    <font-awesome-icon :icon="['fas', 'pen']" />
                  </button>
                  <button
                    @click="removeCompany(row.item._id, row.item.name)"
                    class="btn btn-outline-danger"
                  >
                    <font-awesome-icon :icon="['fas', 'trash-alt']" />
                  </button>
                </div>
                <modal-edit-company
                  :id="row.item._id"
                  :myCompany="row.item"
                  :page="page"
                  :filter="filter"
                />
              </template>
            </b-table>
            <div v-show="!loading" class="pagination-area-config-company">
              <paginate
                :pageCount="systemCompanies.total"
                v-model="page"
                :prevText="'‹'"
                :nextText="'›'"
                :activeClass="'active'"
                :containerClass="'pagination b-pagination'"
                :pageClass="'page-item'"
              >
              </paginate>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="screen"
      id="screen"
      @click="closeInputSegments"
      style="display: none;"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Paginate from 'vuejs-paginate';
import swal from 'sweetalert';
import IdxCard from '@/components/molecules/idx-card';
import ModalEditCompany from '../modal-edit-company';

export default {
  components: { ModalEditCompany, Paginate, IdxCard },

  data: () => ({
    userAuth: null,
    filter: null,
    typingTimer: null,
    corporateName: null,
    name: null,
    cnpj: null,
    qtySms: null,
    qtyEmail: null,
    mySegment: null,
    country: 'Brasil',
    filterSegment: [],
    plan: {
      myPlan: 'demo',
      options: [],
    },
    fields: [],
    file: null,
    page: 1,
    enableSentiment: false,
  }),

  computed: {
    ...mapFields('master', ['loading']),
    ...mapState('master', ['systemCompanies', 'segments']),
    ...mapState('authentication', ['userProfile']),
  },

  watch: {
    page: function watchPage(value) {
      this.updateTable(value);
    },
  },

  methods: {
    ...mapActions('master', [
      'getCompanies',
      'getAllCompanies',
      'registerNewCompany',
      'deleteCompany',
      'setSegments',
    ]),

    removeCompany(id, name) {
      swal({
        title: this.$t('menu.masterSettings.messages.removeCompany.title'),
        text: this.$t('menu.masterSettings.messages.removeCompany.description'),
        icon: 'warning',
        buttons: true,
        dangerMode: true,
      }).then(async (willDelete) => {
        if (willDelete) {
          await this.deleteCompany({
            token: this.userAuth.token,
            companyId: id,
            companyName: name,
          });

          await swal(
            this.$t('menu.masterSettings.removedCompany'),
            '',
            'success',
          );

          await this.updateTable();
        }
      });
    },

    async updateTable() {
      this.loading = true;

      await this.getCompanies({
        token: this.userAuth.token,
        page: this.page,
        limit: '5',
        filter: this.filter,
      });

      this.loading = false;
    },

    filterCompanies() {
      if (this.filter) {
        this.page = 1;
        clearTimeout(this.typingTimer);
        this.typingTimer = setTimeout(this.updateTable, 600);
      } else if (this.filter === '') {
        this.filter = null;
        this.page = 1;
        clearTimeout(this.typingTimer);
        this.typingTimer = setTimeout(this.updateTable, 600);
      }
    },

    cleanFilter() {
      if (this.filter) {
        this.filter = null;
        this.page = 1;
        this.updateTable();
      }
    },

    removeInvalidClass(id) {
      const element = document.getElementById(id);
      for (let i = 0; i <= element.classList.length; i += 1) {
        if (element.classList[i] === 'is-invalid') {
          element.classList.remove('is-invalid');
        }
      }
    },

    searchSegment(event) {
      this.removeInvalidClass(event.target.id);

      this.filterSegment = [];
      const myString = this.replaceSpecialChars(
        event.target.value.toLowerCase(),
      );

      for (let i = 0; i < this.segments.length; i += 1) {
        let segment = this.segments[i].toLowerCase();
        segment = this.replaceSpecialChars(segment);
        if (segment.indexOf(myString) !== -1) {
          this.filterSegment.push(this.segments[i]);
        }
      }

      document.getElementById('options-segment').style.display = 'block';
      document.getElementById('screen').style.display = 'block';
    },

    chooseSegment(segment) {
      this.mySegment = segment;

      document.getElementById('options-segment').style.display = 'none';
      document.getElementById('screen').style.display = 'none';
    },

    addCompany() {
      if (this.validateFields()) {
        this.registerNewCompany({
          token: this.userAuth.token,
          company: {
            corporateName: this.corporateName,
            name: this.name,
            cnpj: this.cnpj,
            segment: this.mySegment,
            country: this.country,
            plan: {
              type: this.plan.myPlan,
              qtyEmail: this.qtyEmail || 0,
              qtySms: this.qtySms || 0,
            },
            file: this.file,
            enableSentimentAnalyze: false,
          },
        })
          .then(() => {
            this.filter = [];
            this.corporateName = null;
            this.name = null;
            this.cnpj = null;
            this.mySegment = null;
            this.country = 'Brasil';
            this.plan.myPlan = 'demo';
            this.enableSentiment = false;

            this.removeInvalidClass('select-plan');

            this.updateTable();

            swal({
              title: this.$t('menu.masterSettings.messages.addCompany.title'),
              text: this.$t(
                'menu.masterSettings.messages.addCompany.description',
              ),
              icon: 'success',
            });

            this.getAllCompanies({
              token: this.userAuth.token,
              justIds: true,
            });
          })
          .catch(() => {
            swal({
              title: this.$t('menu.masterSettings.messages.error.title'),
              text: this.$t('menu.masterSettings.messages.error.description'),
              icon: 'warning',
            });
          });
      }
    },

    validateFields() {
      if (!this.corporateName) {
        document.getElementById('corporate-name').classList.add('is-invalid');
        return false;
      } else if (!this.name) {
        document.getElementById('company-name').classList.add('is-invalid');
        return false;
      } else if (!this.cnpj) {
        document.getElementById('company-cnpj').classList.add('is-invalid');
        return false;
      } else if (!this.mySegment) {
        document.getElementById('company-segment').classList.add('is-invalid');
        return false;
      } else if (!this.plan.myPlan) {
        return false;
      }

      if (
        this.plan.myPlan === 'personalizado' &&
        (!this.qtySms || !this.qtyEmail)
      ) {
        document.getElementById('select-plan').classList.add('is-invalid');
        return false;
      }

      return true;
    },

    replaceSpecialChars(str) {
      const myString = str
        .replace(/[àáâãäå]/, 'a')
        .replace(/[éèê]/, 'e')
        .replace(/[íìî]/, 'i')
        .replace(/[óòô]/, 'o')
        .replace(/[úùû]/, 'u')
        .replace(/[ç]/, 'c');
      return myString;
    },

    closeInputSegments() {
      this.mySegment = null;
      document.getElementById('options-segment').style.display = 'none';
      document.getElementById('screen').style.display = 'none';
    },

    buildSegments() {
      this.$store.state.master.segments = [
        this.$t('menu.masterSettings.segments.foodDrinks'),
        this.$t('menu.masterSettings.segments.artAntiques'),
        this.$t('menu.masterSettings.segments.religiousArticles'),
        this.$t('menu.masterSettings.segments.subscriptionsMagazines'),
        this.$t('menu.masterSettings.segments.automobilesVehicles'),
        this.$t('menu.masterSettings.segments.babiesCompany'),
        this.$t('menu.masterSettings.segments.giftsPromotionalMaterials'),
        this.$t('menu.masterSettings.segments.toysGames'),
        this.$t('menu.masterSettings.segments.houseDecoration'),
        this.$t('menu.masterSettings.segments.collectibles'),
        this.$t('menu.masterSettings.segments.coletiveShopping'),
        this.$t('menu.masterSettings.segments.constructionTools'),
        this.$t('menu.masterSettings.segments.cosmeticsPerfumery'),
        this.$t('menu.masterSettings.segments.coursesEducation'),
        this.$t('menu.masterSettings.segments.vinylsDiscs'),
        this.$t('menu.masterSettings.segments.homeAppliances'),
        this.$t('menu.masterSettings.segments.electronics'),
        this.$t('menu.masterSettings.segments.radioBroadcasters'),
        this.$t('menu.masterSettings.segments.televisionBroadcasters'),
        this.$t('menu.masterSettings.segments.jobs'),
        this.$t('menu.masterSettings.segments.telemarketingCompanies'),
        this.$t('menu.masterSettings.segments.sportsLeisure'),
        this.$t('menu.masterSettings.segments.flowersBasketsGifts'),
        this.$t('menu.masterSettings.segments.photography'),
        this.$t(
          'menu.masterSettings.segments.churchesTemplesReligiousInstitutions',
        ),
        this.$t('menu.masterSettings.segments.industryCommerceBusiness'),
        this.$t('menu.masterSettings.segments.promotionalInflatables'),
        this.$t('menu.masterSettings.segments.computing'),
        this.$t('menu.masterSettings.segments.tickets'),
        this.$t('menu.masterSettings.segments.musicalInstruments'),
        this.$t('menu.masterSettings.segments.jewelry'),
        this.$t('menu.masterSettings.segments.recreation'),
        this.$t('menu.masterSettings.segments.books'),
        this.$t('menu.masterSettings.segments.fashionAccessories'),
        this.$t('menu.masterSettings.segments.digitalMusic'),
        this.$t('menu.masterSettings.segments.businessOpportunities'),
        this.$t('menu.masterSettings.segments.otherServices'),
        this.$t('menu.masterSettings.segments.stationeryOffice'),
        this.$t('menu.masterSettings.segments.easter'),
        this.$t('menu.masterSettings.segments.petShop'),
        this.$t('menu.masterSettings.segments.cheers'),
        this.$t('menu.masterSettings.segments.advocacyService'),
        this.$t(
          'menu.masterSettings.segments.newspaperMagazineDistributionService',
        ),
        this.$t('menu.masterSettings.segments.administrativeServices'),
        this.$t('menu.masterSettings.segments.artisticServices'),
        this.$t('menu.masterSettings.segments.airportServices'),
        this.$t('menu.masterSettings.segments.agencyServices'),
        this.$t('menu.masterSettings.segments.rentalLeasingServices'),
        this.$t('menu.masterSettings.segments.warehousingServices'),
        this.$t('menu.masterSettings.segments.advisoryServices'),
        this.$t(
          'menu.masterSettings.segments.technicalAssistanceServicesFacilities',
        ),
        this.$t('menu.masterSettings.segments.associationServices'),
        this.$t('menu.masterSettings.segments.bloodBankServices'),
        this.$t('menu.masterSettings.segments.libraryServices'),
        this.$t('menu.masterSettings.segments.notaryServices'),
        this.$t('menu.masterSettings.segments.lotteryServices'),
        this.$t('menu.masterSettings.segments.clothingServices'),
        this.$t('menu.masterSettings.segments.consortiumServices'),
        this.$t('menu.masterSettings.segments.consultingServices'),
        this.$t('menu.masterSettings.segments.cooperativeServices'),
        this.$t('menu.masterSettings.segments.dispatcherServices'),
        this.$t('menu.masterSettings.segments.engineeringServices'),
        this.$t('menu.masterSettings.segments.parkingServices'),
        this.$t('menu.masterSettings.segments.shipyardServices'),
        this.$t('menu.masterSettings.segments.exportImportServices'),
        this.$t('menu.masterSettings.segments.geologistServices'),
        this.$t('menu.masterSettings.segments.jewelerServices'),
        this.$t('menu.masterSettings.segments.auctioneerServices'),
        this.$t('menu.masterSettings.segments.cleaningServices'),
        this.$t('menu.masterSettings.segments.convenienceStoreServices'),
        this.$t('menu.masterSettings.segments.laborServices'),
        this.$t('menu.masterSettings.segments.publicOrganServices'),
        this.$t('menu.masterSettings.segments.researchServices'),
        this.$t('menu.masterSettings.segments.portServices'),
        this.$t('menu.masterSettings.segments.healthWellnessServices'),
        this.$t('menu.masterSettings.segments.insuranceServices'),
        this.$t('menu.masterSettings.segments.securityServices'),
        this.$t('menu.masterSettings.segments.signalingServices'),
        this.$t('menu.masterSettings.segments.unionFederationServices'),
        this.$t('menu.masterSettings.segments.translationServices'),
        this.$t('menu.masterSettings.segments.transportServices'),
        this.$t('menu.masterSettings.segments.publicUtilityServices'),
        this.$t(
          'menu.masterSettings.segments.servicesAgricultureLivestockFishFarming',
        ),
        this.$t('menu.masterSettings.segments.foodServices'),
        this.$t('menu.masterSettings.segments.servicesArt'),
        this.$t('menu.masterSettings.segments.communicationServices'),
        this.$t('menu.masterSettings.segments.constructionServices'),
        this.$t('menu.masterSettings.segments.ecologyEnvironmentServices'),
        this.$t(
          'menu.masterSettings.segments.servicesElectronicsMetalMechanics',
        ),
        this.$t('menu.masterSettings.segments.partyEventServices'),
        this.$t('menu.masterSettings.segments.computerServices'),
        this.$t('menu.masterSettings.segments.internetServices'),
        this.$t('menu.masterSettings.segments.jeweleryWatchesOpticalServices'),
        this.$t('menu.masterSettings.segments.technologyServices'),
        this.$t('menu.masterSettings.segments.telephonyServices'),
        this.$t('menu.masterSettings.segments.vehicleServices'),
        this.$t('menu.masterSettings.segments.esotericMysticalServices'),
        this.$t('menu.masterSettings.segments.financialServices'),
        this.$t('menu.masterSettings.segments.funeralServices'),
        this.$t('menu.masterSettings.segments.generalServices'),
        this.$t('menu.masterSettings.segments.graphicEditorialServices'),
        this.$t('menu.masterSettings.segments.animalServices'),
        this.$t('menu.masterSettings.segments.servicesDisabled'),
        this.$t('menu.masterSettings.segments.officeServices'),
        this.$t('menu.masterSettings.segments.clothingForServices'),
        this.$t('menu.masterSettings.segments.socialAAssistanceServices'),
        this.$t('menu.masterSettings.segments.shoppingCenters'),
        this.$t('menu.masterSettings.segments.tobacconist'),
        this.$t('menu.masterSettings.segments.bankFee'),
        this.$t('menu.masterSettings.segments.telephoneCharges'),
        this.$t('menu.masterSettings.segments.telephony'),
        this.$t('menu.masterSettings.segments.tourism'),
      ];
    },
  },

  async created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
    await this.buildSegments();
    this.updateTable();

    this.plan.options = [
      {
        value: 'demo',
        text: this.$t('menu.masterSettings.channelOptions.demo'),
      },
      {
        value: 'basico',
        text: this.$t('menu.masterSettings.channelOptions.basic'),
      },
      {
        value: 'intermediario',
        text: this.$t('menu.masterSettings.channelOptions.intermediate'),
      },
      {
        value: 'avancado',
        text: this.$t('menu.masterSettings.channelOptions.advanced'),
      },
      {
        value: 'personalizado',
        text: this.$t('menu.masterSettings.channelOptions.custom'),
      },
      { value: 'dev', text: this.$t('menu.masterSettings.channelOptions.dev') },
    ];

    this.fields = [
      { key: 'name', label: this.$t('menu.masterSettings.labels.name') },
      { key: 'plan', label: this.$t('menu.masterSettings.labels.limit') },
      {
        key: 'plan.qtyEmail',
        label: this.$t('menu.masterSettings.labels.quantityEmail'),
      },
      {
        key: 'plan.qtySms',
        label: this.$t('menu.masterSettings.labels.quantitySms'),
      },
      { key: 'options', label: this.$t('menu.masterSettings.labels.options') },
    ];
  },
  mounted() {
    if (this.userProfile.type !== 'master') {
      this.$router.push(`/dashboard/${this.userAuth.companyId}`);
    }
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';

.search-companies {
  display: flex;
  flex-direction: row;

  input {
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
  }

  button {
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
  }
}

.options-segment {
  max-height: 200px;
  overflow: auto;
  padding: 5px;
  position: absolute;
  z-index: 10;
  background-color: #fff;
  width: (100% - 7%);
  box-shadow: 0 5px 8px -5px rgba(0, 0, 0, 0.57);

  ul {
    list-style: none;
    padding: 0;
    margin: 0;

    li {
      padding: 5px 13px;
      font-weight: 500;
      cursor: pointer;
    }

    li:hover {
      background-color: $gray-lighter;
    }
  }
}

.body {
  padding: 20px 15px;
  border-top: 0;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;

  .button-area {
    display: flex;
    flex-direction: row;
    align-items: center;
    max-height: 86px;

    button {
      margin-top: 14px;
    }
  }

  .custom-area {
    display: flex;
    flex-direction: row;

    input {
      max-width: 120px;
    }
  }
}

.screen {
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  width: 100%;
}

.pagination-area-config-company >>> a {
  position: relative;
  display: block;
  padding: 0.5rem 0.75rem;
  margin-left: -1px;
  line-height: 1.25;
  color: #4ce595;
  background-color: #fff;
  border: 1px solid #dee2e6;
}
</style>

<style>
.pagination-area-config-company .active a {
  text-decoration: none;
  z-index: 1;
  color: #fff;
  background-color: #4ce595;
  border-color: #4ce595;
}

.pagination-area-config-company a {
  outline: none;
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/master/master-companies/index.vue